import type { NavigateFunction, NavigateOptions, To } from "react-router";

let navigateRef: NavigateFunction | null = null;

export const setNavigate = (n: NavigateFunction) => {
  navigateRef = n;
};

// Module-level navigate for use in Redux thunks (or anywhere outside React).
// Falls back to a hash-fragment assignment if React Router hasn't mounted
// yet (e.g. during early bootstrap before NavigateSetter runs).
export const navigate = (to: To, options?: NavigateOptions) => {
  if (navigateRef) {
    navigateRef(to, options);
  } else if (typeof to === "string") {
    window.location.hash = to.startsWith("#") ? to : `#${to}`;
  }
};
